export default {"src":"/_next/static/media/RTX.973ef908.svg","height":18,"width":18};